var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02747 5.68101C2.38747 6.05234 1.56747 6.23767 1.37214 6.86501C1.17747 7.49167 1.73614 8.14567 2.85414 9.45301L3.14347 9.79101C3.46081 10.1623 3.62014 10.3483 3.69147 10.5777C3.76281 10.8077 3.73881 11.0557 3.69081 11.551L3.64681 12.0023C3.47814 13.747 3.39347 14.619 3.90414 15.0063C4.41481 15.3943 5.18281 15.0403 6.71747 14.3337L7.11547 14.151C7.55147 13.9497 7.76947 13.8497 8.00081 13.8497C8.23214 13.8497 8.45014 13.9497 8.88681 14.151L9.28347 14.3337C10.8188 15.0403 11.5868 15.3937 12.0968 15.007C12.6081 14.619 12.5235 13.747 12.3548 12.0023M13.1475 9.45301C14.2655 8.14634 14.8241 7.49234 14.6295 6.86501C14.4341 6.23767 13.6141 6.05167 11.9741 5.68101L11.5501 5.58501C11.0841 5.47967 10.8515 5.42701 10.6641 5.28501C10.4775 5.14301 10.3575 4.92767 10.1175 4.49701L9.89881 4.10501C9.05414 2.59034 8.63214 1.83301 8.00081 1.83301C7.36947 1.83301 6.94747 2.59034 6.10281 4.10501",
    stroke: "url(#paint0_linear_3283_4259)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_4259",
    x1: 8.00081,
    y1: 1.83301,
    x2: 8.00081,
    y2: 15.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000F30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumAcc);
export default __webpack_public_path__ + "static/media/PremiumAcc.00c0973fbedcc9d5a0915e7e6f911d65.svg";
export { ForwardRef as ReactComponent };